import React from "react";
import Link from "next/link";

const PrivacyPolicy = () => (
  <div className="mt-2 mx-3 md:mx-6 mb-32">
    <p className="text-center text-xl underline font-bold mb-6">
      Personal Data Protection Policy
    </p>
    <section>
      <p className="text-sm font-bold underline mt-10 mb-4">1. INTRODUCTION</p>
      <ol className="text-xs leading-5">
        <li className="mb-6">
          1.1 This is the personal data privacy policy (“Policy”) of IWG ESPORTS
          SDN BHD (202001005673 (1361993-D)), the registered and beneficial
          owner of the [insert IWG website name] website (“we”, “us”, or “our”).
        </li>
        <li className="mb-6">
          1.2 This Policy applies to personal information about individuals
          (customers, vendors, distributors, suppliers, service providers, joint
          venture/business partners, associates, job applicants, employees) held
          by us. We will only process your Personal Data in accordance with the
          Personal Data Protection Act 2010, Malaysia, the applicable
          regulations, guidelines, directives, amendments, orders, suborders and
          anything whatsoever relating to the same made under the Personal Data
          Protection Act 2010, Malaysia and any statutory amendments or
          re-enactments made of the Personal Data Protection Act 2010, Malaysia
          from time to time (collectively referred to as the “PDPA”) as well as
          this Policy.
        </li>
        <li className="mb-6">
          1.3 The PDPA requires us to inform you of your rights in respect of
          your Personal Data that is being processed or that is to be collected
          and further processed by us and the purposes for the data processing.
          The PDPA also requires us to obtain your consent to the processing of
          your Personal Data. In light of the PDPA, we are committed to
          protecting and safeguarding your Personal Data.
        </li>
        <li className="mb-6">
          1.4 By providing your Personal Data to us and/or continuing access to
          our website (“Site”), you declare that you have read and understood
          this Policy and agree to us processing your Personal Data in
          accordance with the manner as set out in this Policy.
        </li>
        <li className="mb-6">
          1.5 We reserve the right to modify, update and/or amend this Policy
          from time to time with reasonable prior notice to you. We will notify
          you of any amendments via announcements on the Site or other
          reasonable and appropriate means. Please check the Site from time to
          time to see if there are amendments to this Policy. Any amendments to
          this Policy will be effective upon notice to you. By continuing to use
          the services and/or access to the Site after being notified of any
          amendments to this Policy, you will be treated as having agreed to and
          accepted those amendments.
        </li>
        <li className="mb-6">
          1.6 If you do not agree to this Policy or any amendments to this
          Policy, we may not be able to render all services to you and you may
          be required to terminate your relevant agreement with us and/or stop
          accessing or using the Site.
        </li>
      </ol>
    </section>
    <section>
      <p className="text-sm font-bold underline mt-10 mb-4">
        2. COLLECTION OF PERSONAL DATA
      </p>
      <ol className="text-xs leading-5">
        <li className="mb-6">
          2.1 The term “Personal Data” means any information in our possession
          or control that relates directly or indirectly to an individual to the
          extent that the individual can be identified or are identifiable from
          that and other information in our possession, such as name, address,
          telephone number, Identification/Passport number, date of birth,
          photograph, email address, household information, personal preference
          and hobbies etc. as well as Sensitive Personal Data as defined under
          the PDPA, which includes but is not limited to, information pertaining
          to the physical or mental health or condition of a data subject and
          religious beliefs.
          <br />
          <br />
          The types of Personal Data collected depend on the purpose of
          collection. We may “process” your Personal Data by way of collecting,
          recording, holding, storing, using and/or disclosing it.
        </li>
        <li className="mb-6">
          2.2 Your Personal Data may be collected from you during your course of
          dealings with us in any way or manner including pursuant to any
          transactions and/or communications made from/with us. We may also
          collect your Personal Data from a variety of sources, including
          without limitation, at any events, seminars, road shows, customer
          satisfaction surveys organised and/or sponsored by us, as well as from
          publicly available sources. Some examples of how personal data can be
          collected, including but not limited to the following:
          <br />
          <br />
          <ul className="list-disc">
            <li className="ml-10 mb-2">
              When you register your details on our website, apps, promotion
              activities or kiosks;
            </li>
            <li className="ml-10 mb-2">
              When you have complete any purchase orders, requests or
              applications for our products or services (whether by phone, by
              our websites, in person, mail, or any other electronically
              applications);
            </li>
            <li className="ml-10 mb-2">
              When you communicate with us whether on our websites and/or
              directly via our customer service centre, or directly via our
              co-workers within our stores in relation to our products and
              services (in person, by email, telephone, direct mail or any other
              means);
            </li>
            <li className="ml-10 mb-2">
              When you conduct certain types of transactions such as refunds of
              items or services you have purchased through our websites or our
              service centres;
            </li>
            <li className="ml-10 mb-2">
              When you enter, and when you interact with us during normal
              events, promotions, competitions, contests, lucky draws, special
              events, or by using devices within our stores (if any);
            </li>
            <li className="ml-10 mb-2">
              Subscribe to any of our membership programmes and/or our loyalty
              programmes;
            </li>
            <li className="ml-10 mb-2">
              Participate in surveys and other types of research; or
            </li>
            <li className="ml-10 mb-2">
              If you are a candidate for employment when you have complete any
              forms in relation to the recruitment and selection process for the
              purpose of assessment. We may also collect information about you
              from your nominated referees where you have authorised us to do
              so.
            </li>
          </ul>
        </li>
        <li className="mb-6">
          2.3 In addition, we may also receive, store and process your Personal
          Data which are provided or made available by any third parties, credit
          reference bodies/ institutions, regulatory and law enforcement
          authorities, for reasons including delivery of our products and/or
          services, performance of conditions of agreements and/or to comply
          with our legal and regulatory obligations.
        </li>
        <li className="mb-6">
          2.4 We may also use your Personal Data to contact you with
          newsletters, marketing or promotional materials and other information
          that may be of interest(s) to you. However, you may at any material
          time opt out of receiving any, or all, of these communications from us
          by ticking or opting on the unsubscribe link or button.
        </li>
        <li className="mb-6">
          2.5 While using our website or any services related thereof, we may
          also collect the following information: sex, age, date of birth, place
          of birth, passport details, citizenship, registration at place of
          residence and actual address, telephone number (work, mobile), details
          of documents on education, qualification, professional training,
          employment agreements, non-disclosure agreements, information on
          bonuses and compensation, information on marital status, family
          members, social security (or other taxpayer identification) number,
          office location and other data.
        </li>
      </ol>
    </section>
    <section>
      <p className="text-sm font-bold underline mt-10 mb-4">
        3. PURPOSE OF ACQUIRING, COLLECTING AND PROCESSING YOUR PERSONAL DATA
      </p>
      <p className="text-xs leading-5 mb-4">
        The Personal Data as provided/furnished by you to us or collected by us
        from you or through such other sources as may be necessary for the
        fulfilment of the purposes at the time it was sought or collected, may
        be processed for the following purposes (collectively referred to as the
        “Purposes”):
      </p>
      <ul className="text-xs leading-5 list-disc">
        <li className="ml-10">
          to communicate and maintain communication with you;
        </li>
        <li className="ml-10">
          to maintain and improve customer relationship and customer support;
        </li>
        <li className="ml-10">
          to assess, process and provide products, services and/or facilities to
          you;
        </li>
        <li className="ml-10">
          to administer and process any payments related to products, services
          and/or facilities requested by you;
        </li>
        <li className="ml-10">to establish your identity and background; </li>
        <li className="ml-10">
          to respond to your enquiries or complaints and resolve any issues and
          disputes which may arise in connection with any dealings with us;
        </li>
        <li className="ml-10">
          to provide you with information and/or updates on our products,
          services, upcoming promotions offered by us and/or events organised by
          us and selected third parties which may be of interest to you from
          time to time;
        </li>
        <li className="ml-10">
          for direct marketing purposes via SMS, phone call, email, fax, mail,
          social media and/or any other appropriate communication channels to
          members of our loyalty programmes in accordance with their consent;
        </li>
        <li className="ml-10">
          to facilitate your participation in, and our administration of, any
          events including contests, promotions or campaigns;
        </li>
        <li className="ml-10">
          to award points in a loyalty or rewards programme;
        </li>
        <li className="ml-10">
          to maintain and update internal record keeping;
        </li>
        <li className="ml-10">for internal administrative purposes; </li>
        <li className="ml-10">
          to detect, prevent and address any technical issue(s) (if any);
        </li>
        <li className="ml-10">
          to notify you about changes to our services and website;
        </li>
        <li className="ml-10">
          to carry out our obligations and enforce our rights arising from any
          contracts that may be entered between you and us, including but not
          limited to for the billing and collection;
        </li>
        <li className="ml-10">
          to send you seasonal greetings messages from time to time;
        </li>
        <li className="ml-10">
          to send you the invitation to join our events and promotions and
          product launch events;
        </li>
        <li className="ml-10">
          to monitor, review and improve our events and promotions, products
          and/or services;
        </li>
        <li className="ml-10">
          to conduct credit reference checks and establish your
          creditworthiness, where necessary, in providing you with the products,
          services and/or facilities;
        </li>
        <li className="ml-10">
          to administer and give effect to your commercial transactions with us
          (such as a tender award, contract for service, tenancy agreement);
        </li>
        <li className="ml-10">
          to process any payments related to your commercial transactions with
          us;
        </li>
        <li className="ml-10">
          to process and analyse your Personal Data either individually or
          collectively with other individuals;
        </li>
        <li className="ml-10">
          to conduct market research or surveys, internal marketing analysis,
          customer profiling activities, analysis of customer patterns and
          choices, planning and statistical and trend analysis in relation to
          our products and/or services;
        </li>
        <li className="ml-10">
          to share any of your Personal Data with the auditor for our internal
          audit and reporting purposes;
        </li>
        <li className="ml-10">
          to share any of your Personal Data pursuant to any agreement or
          document which you have duly entered with us for purposes of seeking
          legal and/or financial advice and/or for purposes of commencing legal
          action;
        </li>
        <li className="ml-10">
          to share any of your Personal Data with our joint venture/business
          partners to jointly develop products and/or services or launch
          marketing campaigns;
        </li>
        <li className="ml-10">
          to share any of your Personal Data with insurance companies necessary
          for the purpose of applying and obtaining insurance policy(ies), if
          necessary;
        </li>
        <li className="ml-10">
          to share any of your Personal Data with financial institutions
          necessary for the purpose of applying and obtaining credit
          facility(ies), if necessary;
        </li>
        <li className="ml-10">
          for audit, risk management and security purposes;
        </li>
        <li className="ml-10">
          for detecting, investigating and preventing fraudulent, prohibited or
          illegal activities;
        </li>
        <li className="ml-10">
          for enabling us to perform our obligations and enforce our rights
          under any agreements or documents that we are a party to;
        </li>
        <li className="ml-10">
          to transfer or assign our rights, interests and obligations under any
          agreements entered into with us;
        </li>
        <li className="ml-10">
          for meeting any applicable legal or regulatory requirements and making
          disclosure under the requirements of any applicable law, regulation,
          direction, court order, by-law, guideline, circular or code applicable
          to us;
        </li>
        <li className="ml-10">
          to enforce or defend our rights and your rights under, and to comply
          with, our obligations under the applicable laws, legislation and
          regulations;
        </li>
        <li className="ml-10">
          to carry out verification and background checks as part of any
          recruitment and selection process in connection with your application
          for employment with us;
        </li>
        <li className="ml-10">
          for any other purposes with your consent; and/or
        </li>
        <li className="ml-10">
          for other purposes required to operate, maintain and better manage our
          business and your relationship with us, which we notify you of at the
          time of obtaining your consent; and you agree and consent to us using
          and processing your Personal Data for the Purposes in the manner as
          identified in this Policy.
          <span className="underline font-semibold">
            If you do not consent to us processing your Personal Data for one or
            more of the Purposes, please notify us at the contact details below.
          </span>
        </li>
      </ul>
    </section>
    <section>
      <p className="text-sm font-bold underline mt-10 mb-4">
        4. CONSEQUENCES OF NOT CONSENTING TO THIS POLICY
      </p>
      <p className="text-xs leading-5 mb-4">
        The collection of your Personal Data by us may be mandatory or voluntary
        in nature depending on the Purposes for which your Personal Data is
        collected. Where it is obligatory for you to provide us with your
        Personal Data, and you fail or choose not to provide us with such data,
        or do not consent to the above or this Policy, we will not be able to
        provide products and/or services or otherwise deal with you.
      </p>
    </section>
    <section>
      <p className="text-sm font-bold underline mt-10 mb-4">
        5. DISCLOSURE OF YOUR PERSONAL DATA
      </p>
      <p className="text-xs leading-5 mb-4">
        We shall not in any way whatsoever sell, rent, transfer or disclose any
        of your Personal Data to any third party without your consent. However,
        we may disclose your Personal Data to the following third parties, for
        one or more of the above Purposes, as the case may be:
      </p>
      <ul className="text-xs leading-5 list-disc">
        <li className="ml-10">
          IWG ESPORTS SDN BHD and its subsidiary companies, related corporations
          and affiliates either in Malaysia or overseas;
        </li>
        <li className="ml-10">
          your immediate family members and/or emergency contact person as may
          be notified to us from time to time;
        </li>
        <li className="ml-10">
          successors in title, attorney, personal representatives and permitted
          assigns to us;
        </li>
        <li className="ml-10">
          any person under a duty of confidentiality to which has undertaken to
          keep your Personal Data confidential which we have engaged to
          discharge our obligations to you;
        </li>
        <li className="ml-10">
          any party in relation to legal proceedings or prospective legal
          proceedings;
        </li>
        <li className="ml-10">
          our auditors, consultants, lawyers, accountants or other financial or
          professional advisers appointed in connection with our business on a
          strictly confidential basis, appointed by us to provide services to
          us;
        </li>
        <li className="ml-10">
          any party nominated or appointed by us either solely or jointly with
          other service providers, for purpose of establishing and maintaining a
          common database where we have a legitimate common interest;
        </li>
        <li className="ml-10">
          data centres and/or servers located within or outside Malaysia for
          data storage purposes or otherwise;
        </li>
        <li className="ml-10">
          payment channels including but not limited to financial institutions
          for purpose of assessing, verifying, effectuating and facilitating
          payment of any amount due to us in connection with your purchase of
          our products and/or services;
        </li>
        <li className="ml-10">
          government agencies, law enforcement agencies, courts, tribunals,
          regulatory bodies, industry regulators, ministries, and/or statutory
          agencies or bodies, offices or municipality in any jurisdiction, if
          required or authorised to do so, to satisfy any applicable law,
          regulation, order or judgment of a court or tribunal or queries from
          the relevant authorities;
        </li>
        <li className="ml-10">
          our joint venture/business partners, third-party product and/or
          service providers, suppliers, vendors, contractors, data processors or
          agents, that provide related products and/or services in connection
          with our business, or discharge or perform one or more of the above
          Purposes and other purposes required to operate and maintain our
          business, including but not limited to call centres, telecommunication
          companies, logistics companies, information technology companies and
          data centres;
        </li>
        <li className="ml-10">
          insurance companies for the purpose of applying and obtaining
          insurance policy(ies), if necessary;
        </li>
        <li className="ml-10">
          financial institutions for the purpose of applying and obtaining
          credit facility(ies), if necessary; · financial institutions,
          merchants and credit card organisations in connection with your
          commercial transactions with us;
        </li>
        <li className="ml-10">
          the general public when you become a winner in a contest by publishing
          your name, photographs and other Personal Data without compensation
          for advertising and publicity purposes;
        </li>
        <li className="ml-10">
          to third-party credit reporting or employment agencies as part of the
          recruitment and selection process and/or otherwise in connection with
          your application for employment with us;
        </li>
        <li className="ml-10">
          to a legal firm, for the purpose of any potential legal suit arising
          from the ordinary course of business;
        </li>
        <li className="ml-10">
          in the event of a potential, proposed or actual sale/disposal of any
          of our business or interest, merger, acquisition, consolidation,
          re-organisation, funding exercise or asset sale relating to us, or in
          the event of winding-up (“Transaction”), your Personal Data may be
          required to be disclosed or transferred to a third party as a result
          of, or in connection with, the Transactions.
        </li>
        <li className="ml-10">
          You hereby acknowledge that such disclosure and transfer may occur and
          permit us to disclose and transfer your Personal Data to such third
          party and its advisors/representatives and/or any other person
          reasonably requiring the same in order for us to operate and maintain
          our business and/or to fully and effectively carry out the activities
          set out in the Purposes.
        </li>
      </ul>
    </section>
    <section>
      <p className="text-sm font-bold underline mt-10 mb-4">
        6. ACCURACY OF YOUR PERSONAL DATA
      </p>
      <p className="text-xs leading-5 mb-4">
        We aim to keep all Personal Data as accurate, complete, not misleading,
        up-to-date and reliable as possible. Therefore, the accuracy of your
        Personal Data depends to a large extent on the information you provide.
        As such, it is a condition of us providing the products, services and/or
        facilities to you that you shall at all material times: -
      </p>
      <ul className="text-xs leading-5 list-disc">
        <li className="ml-10">
          warrant and declare that all your Personal Data submitted or to be
          submitted to us are accurate, not misleading, updated and complete in
          all respects for purposes of acquiring or using the relevant products,
          services and/or facilities, and you have not withheld any Personal
          Data which may be material in any respect and that we are authorised
          to assume the accuracy and up-to-datedness of the Personal Data given
          by you when processing such Personal Data); and
        </li>
        <li className="ml-10">
          promptly updates us and keep us updated as and when such Personal Data
          provided earlier by you to us becomes inaccurate, incomplete,
          misleading, outdated or changes in any way and manner whatsoever by
          contacting us at the contact details below.
        </li>
      </ul>
    </section>
    <section>
      <p className="text-sm font-bold underline mt-10 mb-4">7. YOUR RIGHTS</p>
      <ol className="text-xs leading-5">
        <li className="mb-6">
          7.1 Subject to the exceptions provided under the PDPA, you have the
          right to request for access to, request for a copy of, a request to
          update or correct, your Personal Data held by us. We may charge a
          small fee (such amount as permitted by the PDPA) to cover the
          administration costs involved in processing your request to access
          your Personal Data.
        </li>
        <li className="mb-6">
          7.2 In respect of your right to access and/or correct your Personal
          Data, we have the right to refuse your request to access and/or
          correct your Personal Data for the reasons permitted under the law,
          such as where the expense of providing access to you is
          disproportionate to the risks to your privacy, or where the rights of
          others may also be violated, amongst other reasons.
        </li>
        <li className="mb-6">
          7.2 In respect of your right to access and/or correct your Personal
          Data, we have the right to refuse your request to access and/or
          correct your Personal Data for the reasons permitted under the law,
          such as where the expense of providing access to you is
          disproportionate to the risks to your privacy, or where the rights of
          others may also be violated, amongst other reasons.
        </li>
        <li className="mb-6">
          7.4 In addition, you also have the right, by notice in writing, to
          inform us on your withdrawal (in full or in part) of your consent
          given previously to us subject to any applicable legal restrictions,
          contractual conditions and a reasonable duration of time for the
          withdrawal of consent to be affected. However, your withdrawal of
          consent could result in certain legal consequences arising from such
          withdrawal. In this regard, depending on the extent of your withdrawal
          of consent for us to process your Personal Data, and in such case, it
          may mean that we will not be able to continue with your existing
          relationship with us and/or the contract that you have with us will
          have to be terminated.
        </li>
      </ol>
    </section>
    <section>
      <p className="text-sm font-bold underline mt-10 mb-4">
        8. RETENTION OF YOUR PERSONAL DATA
      </p>
      <ol className="text-xs leading-5">
        <li className="mb-6">
          8.1 Any of your Personal Data provided to us is retained for as long
          as the purposes for which the Personal Data was collected continues;
          your Personal Data is then destroyed from our records and system in
          accordance with our retention policy in the event your Personal Data
          is no longer required for the said purposes unless its further
          retention is required to satisfy a longer retention period to meet our
          operational, legal, regulatory, tax or accounting requirements.
        </li>
        <li className="mb-6">
          8.2 Your information, including Personal Data, may be transferred to –
          and maintained on – computers located outside of your state, province,
          country or other governmental jurisdiction where the data protection
          laws may differ from those of your jurisdiction. If you are located
          outside of Malaysia and choose to provide information to us, please
          note that we transfer the data, including Personal Data, to Malaysia
          and/or any other places as we deemed fit and proper from time to time
          and process it there. Your consent to this Privacy Policy followed by
          your submission of such information represents your agreement to that
          transfer. IWG ESPORTS SDN BHD will take all the steps reasonably
          necessary to ensure that your data is treated securely and in
          accordance with this Personal Data Protection Policy and no transfer
          of your Personal Data will take place to an organisation or a country
          unless there are adequate controls in place including the security of
          your data and other personal information.
        </li>
      </ol>
    </section>
    <section>
      <p className="text-sm font-bold underline mt-10 mb-4">
        9. SECURITY OF YOUR PERSONAL DATA
      </p>
      <ol className="text-xs leading-5">
        <li className="mb-6">
          9.1 We are committed to ensuring that your Personal Data is stored
          securely. In order to prevent unauthorised access, disclosure or other
          similar risks, we endeavour, where practicable, to implement
          appropriate technical, physical, electronic and procedural security
          measures in accordance with the applicable laws and regulations and
          industry standard to safeguard against and prevent the unauthorised or
          unlawful processing of your Personal Data, and the destruction of, or
          accidental loss, damage to, alteration of, unauthorised disclosure of
          or access to your Personal Data.
        </li>
        <li className="mb-6">
          9.2 We will make reasonable updates to its security measures from time
          to time and ensure the authorised third parties only use your Personal
          Data for the Purposes set out in this Policy.
        </li>
        <li className="mb-6">
          9.3 The Internet is not a secure medium. However, we will put in place
          various security procedures with regard to the Site and your
          electronic communications with us. All our employees, joint
          venture/business partners, agents, representatives, attorneys,
          permitted assigns, associates, distributors, contractors, vendors,
          suppliers, data processors, third-party product and/or service
          providers, who have access to, and are associated with the processing
          of your Personal Data, are obliged to respect the confidentiality of
          your Personal Data.
        </li>
        <li className="mb-6">
          9.4 Please be aware that communications over the Internet, such as
          emails/webmails are not secure unless they have been encrypted. Your
          communications may be routed through a number of countries before
          being delivered as this is the nature of the World Wide Web/Internet.
        </li>
        <li className="mb-6">
          9.5 We cannot and do not accept responsibility for any unauthorised
          access or interception or loss of Personal Data that is beyond our
          reasonable control. Hence, you are hereby agreed to indemnify and keep
          us indemnified for any damages, losses, liabilities and actions that
          may be commenced by you in the event any of any unauthorised access or
          interception or loss of Personal Data
        </li>
      </ol>
    </section>
    <section>
      <p className="text-sm font-bold underline mt-10 mb-4">
        10. PERSONAL DATA FROM MINORS AND OTHER INDIVIDUALS
      </p>
      <p className="text-xs leading-5 mb-4">
        To the extent that you have provided (or will provide) Personal Data
        about your family, spouse and/or other dependents, you confirm that you
        have explained to them that their Personal Data will be provided to, and
        processed by, us and you represent and warrant that you have obtained
        their consent to the processing (including disclosure and transfer) of
        their Personal Data in accordance with this Policy and, in respect of
        minors (i.e. individuals under 18 years of age) or individuals not
        legally competent to give consent, you confirm that they have appointed
        you to act for them, to consent on their behalf to the processing
        (including disclosure and transfer) of their Personal Data in accordance
        with this Policy. Our website(s) and services are not intended for use
        by children under the age of 18 (“Child” or “Children”). We do not
        knowingly collect personally identifiable information from Children
        under the majority age of 18. If you become aware that a Child has
        provided us with Personal Data, please contact us. If we become aware
        that we have collected Personal Data from Children without verification
        of parental consent, we take steps to remove that information from our
        servers.
      </p>
    </section>
    <section>
      <p className="text-sm font-bold underline mt-10 mb-4">
        11. TRANSFER OF YOUR PERSONAL DATA OUTSIDE OF MALAYSIA
      </p>
      <p className="text-xs leading-5 mb-4">
        Our information technology storage facilities and servers may be located
        in other jurisdictions outside of Malaysia. This may include, but not
        limited to, instances where your Personal Data may be stored on servers
        located outside Malaysia. In addition, your Personal Data may be
        disclosed or transferred to entities located outside Malaysia or where
        you access the Site from countries outside Malaysia. Please note that
        these foreign entities may be established in countries that might not
        offer a level of data protection that is equivalent to that offered in
        Malaysia under the laws of Malaysia. You hereby expressly consent to us
        transferring your Personal Data outside of Malaysia for such purposes.
        We shall endeavour to ensure that reasonable steps are taken to procure
        that all such third parties outside of Malaysia shall not use your
        Personal Data other than for that part of the Purposes and to adequately
        protect the confidentiality and privacy of your Personal Data.
      </p>
    </section>
    <section>
      <p className="text-sm font-bold underline mt-10 mb-4">
        12. EXTERNAL LINKS &#38; WEBSITE
      </p>
      <ol className="text-xs leading-5">
        <li className="mb-6">
          12.1 External links
          <ul className="list-disc mt-2">
            <li className="ml-10">
              If any part of the Site links you to other websites, those
              websites do not operate under this Policy and we do not accept any
              responsibility or liability or damages arising from those
              websites.
            </li>
            <li className="ml-10">
              Likewise, if you subscribe to an application, content or a product
              from our strategic partner and you subsequently provide your
              Personal Data directly to that third party, that Personal Data
              will be subject to that third party’s privacy/personal data
              protection policy (if they have such a policy) and not to this
              Policy.
            </li>
            <li className="ml-10">
              We strongly recommend you to read and understand the
              privacy/personal data protection statement/policy posted on those
              other websites in order to understand their procedures for
              collecting, processing, using and disclosing personal data and
              before submitting your Personal Data to those websites.
            </li>
          </ul>
        </li>
        <li className="mb-6">
          12.2 Cookies
          <ul className="list-disc mt-2">
            <li className="ml-10">
              We employ an industry standard technology called “cookies”. The
              cookie is a small piece of information stored on the hard drive of
              your computer or device for record-keeping purposes and is used by
              us to track your visits to the Site. Cookies may be used to save
              your preferences for your ease and convenience when using the
              Site. Third party advertising networks may issue their separate
              cookies to your hard drive when serving advertisements.
            </li>
            <li className="ml-10">
              The type of anonymous clickstream data collected by us through the
              cookies may include your internet protocol address, web browser
              software, date and time of visit to the Site, and whether your
              requests (including search requests and clicking on links to parts
              of the Site) were met with success. All such information collected
              through cookies is not Personal Data and you cannot be identified
              from this information. Such information is only used for the
              purpose of managing and creating a better user experience and to
              identify areas for improvement on the Site.
            </li>
            <li className="ml-10">
              The use of cookies is now an industry standard, and you will find
              them used on most major and minor websites. Most browsers are
              initially set up to accept cookies. If you prefer, you can reset
              your browser either to notify you when you have received a cookie
              or to refuse to accept cookies. You should understand and which we
              hereby inform that certain features on the Site will not function
              properly if you set your browser to not accept cookies.
            </li>
            <li className="ml-10">
              Please also refer to our{" "}
              <Link href="/#">
                <a className="underline" style={{ color: "blue" }}>
                  Cookie Policy
                </a>
              </Link>
              . Insofar as cookies are regarded as Personal Data, you have
              agreed and you hereby irrevocably agreed to us that we may process
              such information as set out in the Cookie Policy in accordance
              with the terms of this Policy.
            </li>
          </ul>
        </li>
        <li className="mb-6">
          12.3 Payments
          <ul className="list-disc mt-2">
            <li className="ml-10">
              We may provide paid products and/or services within our website or
              service. In that case, we use third-party services for payment
              processing (e.g. payment processors).
            </li>
            <li className="ml-10">
              We will not store or collect your payment card details. That
              information is provided directly to our third-party payment
              processors whose use of your personal information is governed by
              their Privacy Policy. These payment processors adhere to the
              standards and requirements set by the relevant local authorities
              regulated by the Bank Negara Malaysia (BNM). Such requirements
              help ensure the secure handling of payment information.
            </li>
          </ul>
        </li>
      </ol>
    </section>
    <section>
      <p className="text-sm font-bold underline mt-10 mb-4">
        13. CHANGES TO THIS PERSONAL DATA PROTECTION POLICY
      </p>
      <p className="text-xs leading-5 mb-4">
        We may update our Personal Data Protection Policy from time to time. We
        will notify you of any changes by posting the new Privacy Policy on this
        website. We will let you know via email and/or a notice on our service,
        prior to the change becoming effective and update “effective date” at
        the top of this Personal Data Protection Policy. You are advised to
        review this Personal Data Protection Policy periodically to be aware for
        any new changes. Changes to this Policy are effective when they are
        posted on this page.
      </p>
    </section>
    <section>
      <p className="text-sm font-bold underline mt-10 mb-4">
        14. CONTACT DETAILS
      </p>
      <p className="text-xs leading-5 mb-4">
        If you have any questions about this Policy, or have any further
        queries, or would like to make a complaint or data access or correction
        request in respect of your Personal Data, you may contact us at the
        contact details below:
        <br />
        <br />
        Data Protection Officer (IWG ESPORTS SDN BHD)
        <br />
        <br />
        <p>Address :</p>
        <p>Contact No. :</p>
        <p>Email Address :</p>
      </p>
    </section>
    <hr />

    <div className="flex flex-col md:flex-row justify-between w-full max-w-lg text-sm mt-4">
      <p className="mb-2">Date of issuance:</p>
      <p className="mb-2">day of the month of:</p>
      <p className="mb-2">year 2021.</p>
    </div>
  </div>
);

export default PrivacyPolicy;
